const MAX_STRING_LENGTH = 25;
const CONCATENATE_LENGTH = Math.ceil(MAX_STRING_LENGTH / 2 - 2);

/**
 * Collapses a string with `...` if the length exceeds MAX_STRING_LENGTH
 * @param {string} input
 */
export const compactString = (input) => {
  if (typeof input !== "string" || input.length <= MAX_STRING_LENGTH) return input;

  return input.substring(0, CONCATENATE_LENGTH).trim() + "..." + input.substring(input.length - CONCATENATE_LENGTH).trim();
};

/**
 * Shortens a name string by abbreviating first middle name,
 * ignoring the rest, e.g. Poul Hans Christian Andersen => Poul H. Andersen
 * @param {string} input
 */
export const abbreviateNames = (input) => {
  if (typeof input !== "string") return input;

  const splitName = input.split(" ");
  if (splitName.length <= 2) return input;

  const abbrevMiddleName = splitName[1].slice(0, 1).toUpperCase();
  const lastName = splitName[splitName.length - 1];

  return `${splitName[0]} ${abbrevMiddleName}. ${lastName}`;
};

export function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

/**
 * Hyphenates a CPR number.
 * @param {string|number} input
 */
export function hyphenateCpr(input) {
  if (typeof input !== "number" && typeof input !== "string") {
    throw new Error(`Invalid type: ${typeof input}`);
  }

  const string = input.toString();

  if (string.match(/^\d{6}-\d{4}$/)) {
    return string;
  }

  if (string.length !== 10 || !string.match(/^\d+$/)) {
    throw new Error(`Invalid CPR format: ${input}`);
  }

  const start = string.slice(0, 6);
  const end = string.slice(6, 10);

  return `${start}-${end}`;
}

export function pluralize(count, noun, suffix = "er") {
  return `${count} ${noun}${count !== 1 ? suffix : ""}`;
}

/**
 * Converts a decimal ("1,2", "1.2") or a h:m ("1:12") formatted string to a hh:mm ("01:12") formatted string.
 * @param {String} value
 */
export function hhmmify(value, padHours = true) {
  let string = value.toString();
  const isTime = string.match(/\d*:\d*/);

  if (!isTime) {
    string = string.replace(",", ".");

    let hours = Math.floor((string * 60) / 60);
    let minutes = Math.floor((string * 60) % 60);

    hours = padHours ? hours.toString().padStart(2, "0") : hours;
    minutes = minutes.toString().padStart(2, "0");

    string = `${hours}:${minutes}`;
  } else {
    let [hours, minutes] = string.split(":");

    hours = padHours ? hours.toString().padStart(2, "0") : hours;
    minutes = minutes.toString().padEnd(2, "0");

    string = `${hours}:${minutes}`;
  }

  return string;
}
